import { landingPageTypes, landingPageCriteriaTypes } from 'commons/constants/newLandingPage';

export const getLandingPageType = (pathname: string): string => {
  const landingPageType: any = Object.values(landingPageTypes).find(
    // $FlowFixMe - Github issue: https://github.com/facebook/flow/issues/2221
    (el: string) => pathname.includes(el),
  );
  return landingPageType ?? '';
};
export const getCriteriaValueFromLandingPageType = (landingPageType: string): string => {
  const criteriaEntry: any = Object.entries(landingPageCriteriaTypes).find(
    // $FlowFixMe - Github issue: https://github.com/facebook/flow/issues/2221
    ([key]: any) => landingPageType.toUpperCase() === key,
  );
  return criteriaEntry?.length ? criteriaEntry[1] : '';
};
